import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardText, CardTitle, Col, Container, Modal, Row, } from "reactstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import images
import logo from "../../assets/images/logo-sm.png";
import CarouselPage from "../AuthenticationInner/CarouselPage";
import Select from "react-select";
import useRegistration from "./hook/useRegistration";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { ToastWrapper } from "../../components/Common/CustomToast";
import { REGISTER_USER_INITIAL } from "../../store/auth/register/actionTypes";
import { createSelfNewAccount, registerEmailVerified, registerOtpVerified } from "../../store/auth/register/actions";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../components/ui/tabs"
import SignupForm from "./components/SignupForm"
import VerificationStep from "./components/VerificationStep"

const RegisterNew = (props) => {
    //meta title
    document.title = "Register || Navigating Freight Costs with Precision||Ultimate Rate Management platform"
    const navigateState = useLocation();
    const dispatch = useDispatch();
    const [step, setStep] = useState(1);
    const [confirmEmail, setConfirmEmail] = useState("");
    const [passwordShow, setPasswordShow] = useState(false)
    const { emailVerified, otpVerified, onBoarding, onBoardingFailed } = useSelector((state) => state?.Account);
    const navigate = useNavigate();
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [redirectCountdown, setRedirectCountdown] = useState(10);
    const [isEmailClick, setIsEmailClick] = useState(false);
    const [isOtpClick, setIsOtpClick] = useState(false);
    const [isOnBoardingClick, setIsOnBoardingClick] = useState(false);
    const [companyAccountTypeLabel, setCompanyAccountTypeLabel] = useState('Agent');
    const [companyAccountType, setCompanyAccountType] = useState('AGENT');
    const [companyAccountTypeError, setCompanyAccountTypeError] = useState(false);
    const [timerStarted, setTimerStarted] = useState(false);
    const [phoneNumberQuery, setPhoneNumberQuery] = useState('');
    const [phoneNumberDebouncedQuery, setPhoneNumberDebouncedQuery] = useState('');

    const { emailValidationSchema, sendEmailInitialValues, country_master_isd_icd,
        otpValidationSchema, createAccountInitialValues, createAccountValidationSchema, resetRegistration } = useRegistration();

    useEffect(() => {
        const handler = setTimeout(() => {
            setPhoneNumberDebouncedQuery(phoneNumberQuery);
        }, 500); // 500ms delay

        return () => {
            clearTimeout(handler);
        };
    }, [phoneNumberQuery]);

    useEffect(() => {
        if (phoneNumberDebouncedQuery) {
            checkPhoneNumberIsValid(phoneNumberDebouncedQuery);
        }
    }, [phoneNumberDebouncedQuery]);

    const checkPhoneNumberIsValid = (numberQuery) => {
        console.log(numberQuery, "PhoneNumberQuery");
    }

    useEffect(() => {
        console.log(emailVerified, "emailVerified", step, "step");
        if (emailVerified === true && step === 1) {
            otpFormik.setFieldValue("email", confirmEmail);
            setStep(2);
        }
    }, [emailVerified]);

    useEffect(() => {
        if (otpVerified === true && step === 2) {
            setStep(3);
            //createAccountFormik.setFieldValue("password", generatePassword());
            createAccountFormik.setFieldValue("email", confirmEmail);
        }
    }, [otpVerified]);

    useEffect(() => {
        if (onBoarding === true && step === 3) {
            setShowSuccessModal(true);
            const interval = setInterval(() => {
                setRedirectCountdown((prev) => {
                    if (prev <= 1) {
                        setStep(1);
                        resetRegistration();
                        clearInterval(interval);
                        setShowSuccessModal(false);
                        navigate('/login');
                        window.reload();
                    }
                    return prev - 1;
                });
            }, 1000);

            return () => clearInterval(interval);
        }
    }, [onBoarding]);

    useEffect(() => {
        if (onBoardingFailed === true) {
            setIsEmailClick(false);
            setIsOnBoardingClick(false);
        }
    }, [onBoardingFailed]);



    const sendEmailFormik = useFormik({
        enableReinitialize: true,
        initialValues: sendEmailInitialValues,
        validationSchema: emailValidationSchema,
        onSubmit: (values) => {
            if (companyAccountType === '') {
                setCompanyAccountTypeError(true);
            } else {
                setTimerStarted(true);
                setIsEmailClick(true);
                const payload = {
                    email: values.email
                };
                otpFormik.resetForm();
                dispatch(registerEmailVerified(payload));
            }
        },
    });

    const otpFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            otp: Array(6).fill(""),
        },
        validationSchema: otpValidationSchema,
        onSubmit: (values) => {
            setIsOtpClick(true);
            const payload = {
                email: values.email || confirmEmail,
                otp: values.otp.join(""),
            };
            console.log(payload, "in Hook");
            createAccountFormik.resetForm();
            dispatch(registerOtpVerified(payload));
        },
    })

    const createAccountFormik = useFormik({
        enableReinitialize: true,
        initialValues: createAccountInitialValues,
        validationSchema: createAccountValidationSchema,
        onSubmit: (values) => {
            setIsOnBoardingClick(true);
            const payload = {
                companyName: values.companyName,
                firstName: values.firstName,
                lastName: values.lastName,
                email: values.email || confirmEmail,
                password: values.password,
                opCode: values.opCode,
                tenant: {
                    name: values.companyName,
                    firstName: values.firstName,
                    lastName: values.lastName,
                    logo: "",
                    logoPath: "",
                    contactName: values.firstName,
                    contactNumber: values.phoneNumber,
                    email: values.email || confirmEmail,
                    industryType: companyAccountType,
                    opCode: values.opCode,
                }
            }
            dispatch(createSelfNewAccount(payload));
            //console.log(values, "Create account in Hook");
        }
    });

    const handleAgentLogin = () => {
        window.location.href = process.env.REACT_APP_SHIPPER_FRONTEND_URL + "/register";
    };

    // const handleOtpChange = (index, value) => {
    //     if (!/^[0-9]?$/.test(value)) return;
    //     if (value.length > 1) return; // Allow only one character
    //     const otpArray = [...otpFormik.values.otp];
    //     otpArray[index] = value;
    //     otpFormik.setFieldValue("otp", otpArray);
    //     if (value && index < 5) {
    //         otpInputs.current[index + 1].focus();
    //     }
    // };

    return (
        <>
            <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
                <Card className="shadow p-4" style={{ minWidth: '460px', maxWidth: '460px' }}>
                    <CardBody>
                        <div id="welcome" className="mb-2 text-center" style={{ marginBottom: 0 }}>
                            <Link to="/dashboard" className="d-block auth-logo">
                                <img src={logo} alt="Logo" height="64" style={{
                                    display: "block",
                                    margin: "0 auto",
                                    padding: 0,
                                    lineHeight: 1,
                                    verticalAlign: "middle",
                                    border: "none",
                                    maxHeight: "64px",
                                }} />
                            </Link>
                        </div>
                        <CardTitle tag="h4" className="text-center mb-1">Create Account 👋</CardTitle>
                        <CardText className="text-center text-muted mb-4">Join TariffTales as an Agent</CardText>
                        <div
                            className="mt-2"
                            style={companyAccountTypeError ? { border: '1px solid red', borderRadius: '5px' } : {}}
                        >
                            <button
                                type="button"
                                className="btn btn-primary w-100"
                                onClick={() => {
                                    setCompanyAccountTypeError(false);
                                    setCompanyAccountType("AGENT");
                                    setCompanyAccountTypeLabel("Agent");
                                }}
                            >
                                Agent
                            </button>
                        </div>
                        <div className="mt-2">
                            {companyAccountTypeError && (<span style={{ color: 'red' }}>Please select company type</span>)}
                        </div>


                        {step === 1 && (
                            <div className="mt-4">
                                <SignupForm.Email
                                    sendEmailFormik={sendEmailFormik}
                                    setEmail={setConfirmEmail}
                                    isEmailClick={isEmailClick}
                                    onSubmit={sendEmailFormik.handleSubmit}
                                />
                            </div>
                        )}

                        {step === 2 && (
                            <div className="mt-4">
                                <VerificationStep
                                    otpFormik={otpFormik}
                                    timerStarted={timerStarted}
                                    email={confirmEmail}
                                    onVerified={otpFormik.handleSubmit}
                                    onResend={sendEmailFormik.handleSubmit}
                                    onBack={() => { setIsEmailClick(false); setStep(1); }}
                                />
                            </div>
                        )}

                        {step === 3 && (
                            <div className="mt-4">
                                <SignupForm.Details
                                    userType={companyAccountTypeLabel}
                                    accountFormik={createAccountFormik}
                                    isSubmitting={isOnBoardingClick}
                                    passwordShow={passwordShow}
                                    setPhoneNumber={setPhoneNumberQuery}
                                    setPasswordShow={setPasswordShow}
                                    country_master_isd_icd={country_master_isd_icd}
                                    email={confirmEmail}
                                    onBack={() => { setIsEmailClick(false); setStep(1); }}
                                    onSubmit={createAccountFormik.handleSubmit}
                                />
                            </div>
                        )}

                        <div className="text-center login_account_text mt-3">
                            <p className="text-muted mb-0">
                                Already have an account ?
                                <Link to="/login" onClick={() => { window.reload(); }} className="text-primary fw-semibold" > Login </Link>
                            </p>
                        </div>
                        <p className="text-center text-muted mt-3">
                            Signup As?{' '}
                            <Link onClick={handleAgentLogin} className="text-primary hover:underline">
                                Shipper
                            </Link>
                        </p>
                    </CardBody>
                </Card>
            </div>
            <Modal size="sm" isOpen={showSuccessModal} toggle={() => setShowSuccessModal(!showSuccessModal)} centered backdrop="static">
                <div className="modal-body text-center">
                    <img
                        src="https://app-storage.tarifftales.com/creat-account-png-1760551046854.png"
                        alt="Register Success"
                        style={{ width: "100px", height: "100px", objectFit: "cover" }}
                        className="mb-3" />

                    <div className="alert alert-success d-inline-flex align-items-center justify-content-center w-100 mb-0" role="alert">
                        <i className="bi bi-check-circle-fill me-2"></i>
                        <span>
                            Account Created! Redirecting in <strong>{redirectCountdown}</strong> second{redirectCountdown !== 1 ? "s" : ""}...
                        </span>
                    </div>
                </div>
            </Modal>
            <ToastWrapper />
        </>
    );
};

export default RegisterNew;
